module.exports = __webpack_public_path__ + "static/media/practice_header.b92589e6.png";